// extracted by css-extract-rspack-plugin
export default {"mapContainer":"mapContainer-QIJ12H","mapFrame":"mapFrame-j4Nw8T","webglLink":"webglLink-inrye0"};